export default {
  PUSH_SUB_DEPARTMENTS: 'PUSH_SUB_DEPARTMENTS',
  PUSH_SUB_DEPARTMENT: 'PUSH_SUB_DEPARTMENT'
};